import { VStack } from '@hover/blueprint';
import React from 'react';
import { Link } from 'react-router-dom';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { usePartnerCobranding } from 'src/modules/homeownerApp/hooks/usePartner';
import { buttonPressed } from 'src/shared/telemetry';

import { CobrandLogo } from '../../CobrandLogo/CobrandLogo';
import { isCobrandCategory } from '../../Customize/partners';
import { TileButtonPictogram } from '../../TileButton';

import type { EmbedMenuItem } from './EmbedCustomizeMenu';

const LandingPagePictogramButton = ({
  item,
  isLoading,
  toPath,
}: {
  item: EmbedMenuItem;
  isLoading: boolean;
  toPath: { pathname: string };
}) => {
  const { trackingData: contextTrackingData } = useHomeownerAppContext();
  const cobranding = usePartnerCobranding();
  return (
    <VStack data-testid="customize-menu-item" key={item.label}>
      <TileButtonPictogram
        as={Link}
        colorScheme="dark"
        disabled={isLoading}
        icon={item.icon}
        isLoading={isLoading}
        label={item.label}
        onClick={() => {
          buttonPressed({
            ...contextTrackingData,
            button_text: item.label,
            primary_cta: false,
            track_id: 'edit-category',
          });
        }}
        pictogram={item.pictogram}
        textDecoration="none"
        textSize={200}
        to={toPath}
        width={{ base: '72px', tablet: '90px' }}
      />
      {cobranding &&
        item.category &&
        isCobrandCategory(cobranding.type, item.category) && (
          <CobrandLogo colorMode="dark" hideHoverMark />
        )}
    </VStack>
  );
};

export { LandingPagePictogramButton };
